<template>
  <div :class="[
    'panel-content question-container px-xs-4 px-md-0 pt-xs-4 pt-md-80',
    { 'no-video': !symptom.video },
  ]">
    <div class="heading">
      <h1 class="question-symptom" v-html="symptom.label"></h1>
      <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
    </div>

    <div class="row mb-xs-20">
      <div
        v-if="symptom.video"
        :class="[ 'video col-xs-12', { 'col-xl-6': symptom.video }, 'p-xs-4 p-lg-20 mb-xs-4 bg-sma-turquoise-10' ]"
      >
        <div class="video-container">
          <video
            ref="symptom-video"
            :poster="symptom.poster"
            playsinline
            controls
            preload="none"
            @pause="playedVideo = false"
          ><source :src="symptom.video" type="video/mp4"></video>
          <img
            v-if="!playedVideo"
            class="video-trigger"
            :src="symptom.poster"
            alt="..."
            @click.stop="playVideo()"
          >
        </div>
        <div class="info-button-container">
          <div class="show-info show-info-light" @click.stop="openSymptomPopup()"></div>
          <p
            class="small fg-sma-fuchsia text-weight-bold text-uppercase cursor-pointer"
            @click.stop="openSymptomPopup()"
          >
            <span v-html="$getTemplatedString('GLOBAL_MORE_ABOUT', { 'subject': symptom.label })"></span>
          </p>
        </div>
      </div>
      <div :class="[ 'questions col-xs-12', { 'col-xl-6': symptom.video } ]">
        <p class="question-heading medium text-weight-bold fg-sma-black mb-xs-4" v-html="question.heading"></p>
        <p class="smaller fg-sma-black-75 mb-xs-4" v-html="$getString('QUESTION_SELECT_ALL_CONCERNED')"></p>
          
        <ul class="symptomlist column-list bordered">
          <li v-for="(option, index) in question.options" :key="index" class="symptom-wrapper">
            <div :class="[ 'symptom-header checkbox-container br-1', { active: question.answers.indexOf(index) > -1 } ]" @click.stop="select(index)">
              <div :class="[ 'checkbox', { checked: question.answers.indexOf(index) > -1 } ]"></div>
              <p class="mr-xs-4" v-html="option"></p>
            </div>
          </li>
          <li class="symptom-wrapper no-shadow">
            <div :class="[ 'symptom-header checkbox-container no-selection br-1', { active: question.answers.indexOf(-1) > -1 } ]" @click.stop="select(-1)">
              <div :class="[ 'checkbox', { checked: question.answers.indexOf(-1) > -1 } ]"></div>
              <p v-if="question.options.length > 1" v-html="$getString('GLOBAL_NOT_CONCERNED')"></p>
              <p v-else v-html="$getString('GLOBAL_NOT_CONCERNED_SINGLE')"></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'StageQuestion',
  props: {
    symptom: {
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    page: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      ageGroup: null,
      playedVideo: false,
    }
  },
  methods: {
    openSymptomPopup() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_info`,
      } });

      this.$emit('action', { type: 'open-popup', data: {
        type: 'symptom',
        heading: this.symptom.label,
        items: this.symptom.popupList,
      }});
    },
    select(index) {
      const analyticsValue = index > -1 ? this.question.analytics.options[index] : 'Not_concerned';
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_${analyticsValue}`,
      } });

      this.$emit('action', { type: 'select-answer', data: index });
    },
    playVideo() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_play_video`,
      } });

      this.playedVideo = true;
      const video = this.$refs['symptom-video'];
      if (video) {
        video.play();
      }
    },
  },
  mounted() {
    this.ageGroup = this.$store.getters.ageGroup;
  },
}
</script>
